export default "__VITE_ASSET__Dw7gfkL6__"